const context = require.context('./news', true, /\.js$/);

const parseNewsDate = (value) => new Date(value).getTime();

export const news = context
  .keys()
  .map((key, i) => ({
    ...context(key).default,
    i,
  }))
  .sort((a, b) => {
    const dateDiff = parseNewsDate(b.date) - parseNewsDate(a.date);
    if (dateDiff !== 0) return dateDiff;
    return a.i - b.i;
  })
  .map(({ i, ...item }) => item);
